export type FilterOption = {
  value: string;
  label: string;
};

type FilterBarProps<T extends string> = {
  filters: Record<T, string>;
  options: Record<T, FilterOption[]>;
  labels: Record<T, string>;
  onChange: (key: T, value: string) => void;
  onReset: () => void;
};

export function FilterBar<T extends string>({ filters, options, labels, onChange, onReset }: FilterBarProps<T>) {
  const keys = Object.keys(filters) as T[];

  return (
    <section className="filter-bar" aria-label="Filtros">
      {keys.map((key) => (
        <label className="field" key={key}>
          <span>{labels[key]}</span>
          <select value={filters[key]} onChange={(event) => onChange(key, event.target.value)}>
            <option value="">Todos</option>
            {options[key].map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
      ))}
      <button type="button" className="button button--primary" onClick={onReset}>Limpar filtros</button>
    </section>
  );
}
